export default __webpack_public_path__ + "static/media/detected-reco-img.67257a75.png";